<template>
  <v-card
    :class="$vuetify.breakpoint.mobile ? 'flex-column' :'justify-space-between'"
    :dark="true"
    class="d-flex pa-5"
    color="primary darken-1"
  >
    <div
      :class="$vuetify.breakpoint.mobile ? 'mb-5' :'align-center'"
      class="d-flex"
    >
      <div
        class="white--text titre-h4-bandeau mr-2"
      >
        Toutes mes cultures pour la récolte
      </div>
      <BaseSelect
        :items="listeAnneeRecolte"
        :libelle-btn="anneeRecolte"
        @onClick="onSelectAnnee($event)"
      />
    </div>
    <div
      :class="$vuetify.breakpoint.mobile ? 'justify-space-between' : 'align-center mr-12'"
      class="d-flex align-center"
    >
      <div :class="$vuetify.breakpoint.mobile ? '' : 'mr-12'">
        <span class="titre-h4-bandeau white--text mr-2">
          SAU
        </span>
        <span class="chiffre white--text">
          {{ resumeRecolte.sau | roundNumber }} ha
        </span>
      </div>
      <div>
        <span class="chiffre white--text mr-2 ml-5">
          {{ resumeRecolte.nbCultures }}
        </span>
        <span class="titre-h4-bandeau white--text">
          {{ uniteCulture }}
        </span>
      </div>
    </div>
  </v-card>
</template>

<script>
import BaseSelect from '@/components/common/base-select.vue'

export default {
  name: 'ResumeCulture',
  components: {BaseSelect},
  props: {
    anneeRecolte: {
      type: String,
      required: true
    },
    recoltes: {
      type: Array,
      required: true
    },
    resumeRecolte: {
      type: Object,
      default: () => { }
    },
  },

  computed: {
    uniteCulture () {
      return 'culture'+ (this.resumeRecolte.nbCultures > 1 ? 's' : '')
    },
    listeAnneeRecolte () {
      return this.recoltes.map(annee => {
        return {
          code: annee,
          libelle: annee
        }
      })
    }
  },

  methods : {
    onSelectAnnee (newAnnee) {
      this.$emit('selectAnneeRecolte', newAnnee)
    }
  }
}
</script>
